import { render } from "./IconLink.vue?vue&type=template&id=5e391e1c&scoped=true"
import script from "./IconLink.vue?vue&type=script&lang=js"
export * from "./IconLink.vue?vue&type=script&lang=js"

import "./IconLink.vue?vue&type=style&index=0&id=5e391e1c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e391e1c"]])

export default __exports__